const DB_NAME = 'PlaygroundsVideoCacheDB';
const STORE_NAME = 'video_clips';
const DB_VERSION = 1;

function openVideoDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || !window.indexedDB) {
      reject(new Error('IndexedDB not available'));
      return;
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function saveVideoToCache(clipId: string, videoDataUrlOrBlob: string): Promise<void> {
  if (!clipId || !videoDataUrlOrBlob) return;
  try {
    const db = await openVideoDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.put(videoDataUrlOrBlob, clipId);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
  } catch (err) {
    console.error('Failed to save video clip to IndexedDB cache:', err);
  }
}

export async function getVideoFromCache(clipId: string): Promise<string | null> {
  if (!clipId) return null;
  try {
    const db = await openVideoDB();
    return new Promise((resolve) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(clipId);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => resolve(null);
    });
  } catch (err) {
    console.error('Failed to retrieve video clip from IndexedDB cache:', err);
    return null;
  }
}

export function clearLegacyVideoCache(): void {
  if (typeof window === 'undefined' || !window.indexedDB) return;
  try {
    indexedDB.deleteDatabase(DB_NAME);
  } catch (err) {
    console.warn('Unable to clear legacy video cache:', err);
  }
}

export function getSampleFallbackVideo(sport?: string): string {
  switch (sport?.toLowerCase()) {
    case 'baseball':
      return 'https://assets.mixkit.co/videos/preview/mixkit-baseball-player-batting-in-a-stadium-41584-large.mp4';
    case 'football':
      return 'https://assets.mixkit.co/videos/preview/mixkit-american-football-players-during-a-game-41857-large.mp4';
    case 'soccer':
      return 'https://assets.mixkit.co/videos/preview/mixkit-top-shot-of-a-soccer-field-during-a-game-41583-large.mp4';
    case 'pickleball':
      return 'https://assets.mixkit.co/videos/preview/mixkit-tennis-player-hitting-a-ball-41582-large.mp4';
    case 'basketball':
    default:
      return 'https://assets.mixkit.co/videos/preview/mixkit-basketball-player-dunking-a-ball-40866-large.mp4';
  }
}
